import { Link, NavLink } from "react-router-dom";
import { useState } from "react";

const LeftNav1 = () => {

  const [isCollapsed, setIsCollapsed] = useState(localStorage.getItem('col') === 'true');

  const toggleCollapse = () => {
    const updatedValue = !isCollapsed;
    setIsCollapsed(updatedValue);
    localStorage.setItem('col', updatedValue);
  };

  return (<>
    <div className={`rounded-3xs ${!isCollapsed && 'w-[190px]'} bg-white shadow-[0px_0px_15px_rgba(0,_0,_0,_0.15)] max-h-full flex flex-col py-[15px] px-5 box-border gap-[11px] ${!isCollapsed && 'text-left'} text-base`}>
      <div className="self-stretch flex flex-row items-center justify-between cursor-pointer text-yellowgreen">
        {!isCollapsed && <div className="relative font-semibold inline-block w-[109px] text-[14px] shrink-0">
          CONTENT
        </div>}
        <div onClick={toggleCollapse} className="rounded-sm bg-cornflowerblue overflow-hidden flex flex-row py-1 px-[13px] items-start justify-start">
          <img
            className="relative rounded-3xs w-[12px] h-[12px]"
            alt=""
            src={`${!isCollapsed ? '/arrow-collapse.svg' : '/arrow-collapse1.svg'}`}
          />
        </div>
      </div>
      {!isCollapsed ? <>
        <img
          className="h-0.5 self-center"
          alt=""
          src="/seprator-gradient.svg"
        />
        <div className="relative font-semibold inline-block w-[118.01px] text-[13px] shrink-0">
          Introduction
        </div>
        <NavLink to="/useraccounts" className="decoration-transparent" id="useraccounts">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-user-active.svg"
                />
                <div className="relative left-6 inline-block w-[100px] shrink-0 text-[12px]">
                  User Accounts
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-user.svg"
                />
                <div className="relative text-darkslategray inline-block w-[100px] shrink-0 text-[12px]" >
                  User Accounts
                </div>
              </div>
          )}

        </NavLink>
        <NavLink to="/network" className="decoration-transparent" id="network">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-networing1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Network and Volume
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-networing.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Network and Volume
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/screenshare" className="decoration-transparent" id="screenshare">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-screen-share1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Screen Sharing
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-screen-share.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Screen Sharing
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/gurusupport" className="decoration-transparent" id="gurusupport">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-guru1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Guru Support
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-guru.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Guru Support
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/widgets" className="decoration-transparent" id="widgets">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-widgets1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Widgets
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-widgets.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Widgets
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/navigationbar" className="decoration-transparent" id="navigationbar">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-navigation1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Navigation Bar
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-navigation.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Navigation Bar
                </div>
              </div>
          )}
        </NavLink>
        <img
          className="h-0.5 self-center"
          alt=""
          src="/seprator-1.svg"
        />
        <div className="relative font-semibold inline-block w-[116.16px] text-[13px] shrink-0">
          Applications
        </div>
        <NavLink to="/whiteboard" className="decoration-transparent" id="whiteboard">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-whitebord1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Whiteboard
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-whitebord.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Whiteboard
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/onescreenshare" className="decoration-transparent" id="onescreenshare">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-one-share1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  OneScreen Share
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-one-share.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  OneScreen Share
                </div>
              </div>
          )}
        </NavLink>
        <NavLink to="/source" className="decoration-transparent" id="source">
          {({ isActive, isPending }) => (
            isActive ?
              <div className="relative w-[170px] right-2 h-[24px] text-white bg-lime-500 rounded-[4px]">
                <img
                  className="relative top-[2px] left-2 w-[14px] h-[14px]"
                  alt=""
                  src="/icon-source1.svg"
                />
                <div className="relative left-6 inline-block w-[122px] shrink-0 text-[12px]">
                  Source
                </div>
              </div>
              :
              <div className="flex flex-row items-center justify-start gap-[15px] cursor-pointer">
                <img
                  className="relative w-[14px] h-[14px]"
                  alt=""
                  src="/icon-source.svg"
                />
                <div className="relative text-darkslategray inline-block w-[179.16px] shrink-0  text-[12px]">
                  Source
                </div>
              </div>
          )}
        </NavLink> </> :
        <>
          <img
            className="h-1 w-9 self-center"
            alt=""
            src="/seprator-gradient.svg"
          />
          <NavLink to="/useraccounts" className="decoration-transparent" id="useraccounts">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-user-active.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-user.svg"
                  />
                </div>
            )}

          </NavLink>
          <NavLink to="/network" className="decoration-transparent" id="network">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px] "
                    alt=""
                    src="/icon-networing1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-networing.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/screenshare" className="decoration-transparent" id="screenshare">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-screen-share1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-screen-share.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/gurusupport" className="decoration-transparent" id="gurusupport">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-guru1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-guru.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/widgets" className="decoration-transparent" id="widgets">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-widgets1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-widgets.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/navigationbar" className="decoration-transparent" id="navigationbar">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-navigation1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-navigation.svg"
                  />
                </div>
            )}
          </NavLink>
          <img
            className="h-1 w-9 self-center"
            alt=""
            src="/seprator-1.svg"
          />
          <NavLink to="/whiteboard" className="decoration-transparent" id="whiteboard">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-whitebord1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-whitebord.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/onescreenshare" className="decoration-transparent" id="onescreenshare">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-one-share1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-one-share.svg"
                  />
                </div>
            )}
          </NavLink>
          <NavLink to="/source" className="decoration-transparent" id="source">
            {({ isActive, isPending }) => (
              isActive ?
                <div className="relative h-[24px] text-white bg-lime-500 rounded-[4px]">
                  <img
                    className="relative top-[2px]"
                    alt=""
                    src="/icon-source1.svg"
                  />
                </div>
                :
                <div className="gap-[15px] cursor-pointer">
                  <img
                    className="relative"
                    alt=""
                    src="/icon-source.svg"
                  />
                </div>
            )}
          </NavLink> </>}
    </div>
    <div className={`rounded-3xs ${!isCollapsed && 'w-[190px]'} bg-white shadow-[0px_0px_15px_rgba(0,_0,_0,_0.15)] max-h-full flex flex-col mt-2 box-border ${!isCollapsed && 'text-left'} text-base`}>
      <NavLink to="https://www.youtube.com/embed/playlist?list=PLZP7o2aOzdejgC55WDzoT3PItj-geu4r9" className="decoration-transparent" id="playlist">
        {
          !isCollapsed ?
            <div className="relative h-[28px] text-white bg-lime-500 rounded-[6px] text-center">
              {/* <img
                className="relative top-[2px]"
                alt=""
                src="/icon-one-share1.svg"
              /> */}
              <div className="relative inline-block mt-[6px] shrink-0 text-[12px]">
                View extended training playlist
              </div>
            </div>
            :
            <div className="gap-[15px] h-7 cursor-pointer bg-lime-500 rounded-[6px]">
              <img
                className="relative mt-2 h-4"
                alt=""
                src="/playlist-videos-icon.svg"
              />
            </div>
        }
      </NavLink>
    </div>
  </>
  );
};

export default LeftNav1;
